import axios from '@/plugins/axios.js';

export default {
    'Videos/AUTO_SAVE': {
        fields: ['title', 'caption', 'description'],

        callback: async (store, mutation) => {
            const { item } = mutation.payload;

            if (!item.title || !item.id || item.title.length > 191) return;

            store.dispatch('AutoSave/setSaving', mutation);

            await axios.put(`/api/videos/${item.reference_id}`, item);

            store.dispatch('AutoSave/setSaved', mutation);
        },
    },
};
